import InputTypesEnum from '../../Enums/InputTypesEnum';

/**
 * Presentation groupings used by `InputWithClearBase` to decide which chrome
 * (clear button, label, wrapper) an input type gets. These were previously
 * inlined as anonymous arrays inside three separate methods; naming them here
 * keeps the behaviour in one place and self-documenting.
 */

/** Types that never show the clear ("eraser") button. */
export const TYPES_WITHOUT_ERASER = [
  InputTypesEnum.OnOff,
  InputTypesEnum.SingleCheckBox,
  InputTypesEnum.PlaceHolder,
  InputTypesEnum.MultiChoice,
  InputTypesEnum.Checkbox,
  InputTypesEnum.EmptySpace,
  InputTypesEnum.ClientMultiChoice,
  InputTypesEnum.ClientMultiChoiceAll,
  InputTypesEnum.DataFlowMapMultiChoice,
  InputTypesEnum.CountryMultiChoice,
  InputTypesEnum.CountryCodeMultiChoice,
  InputTypesEnum.CountryNameMultiChoice,
  InputTypesEnum.ThirdPartySourceMultiChoice,
  InputTypesEnum.ThirdPartySourceEvaluatorMultiChoice,
  InputTypesEnum.Notes,
  InputTypesEnum.TextReadOnly,
  InputTypesEnum.FileUploadField,
  InputTypesEnum.CaspianRolesMultiCheck,
  InputTypesEnum.TextBoxReadOnly,
  InputTypesEnum.SourceQuestionSelect,
  // The value IS the link (e.g. the download-template href) — erasing it just breaks the anchor.
  InputTypesEnum.Link,
];

/** Types that render without the field label. */
export const TYPES_WITHOUT_LABEL = [
  InputTypesEnum.EmptySpace,
  InputTypesEnum.MultiChoice,
  InputTypesEnum.Text2,
  InputTypesEnum.SingleCheckBox,
];

/** Types that render the bare input only — no surrounding label/eraser/error chrome. */
export const TYPES_RENDERED_WITHOUT_CHROME = [
  InputTypesEnum.Text2,
  InputTypesEnum.SingleCheckBox,
  InputTypesEnum.TextBox2,
  InputTypesEnum.NumberWithTwoDecimalPlaces2,
  InputTypesEnum.Number2,
  InputTypesEnum.EmptyYesNoSelect2,
  InputTypesEnum.Select2,
];
